import { Component, inject, OnInit } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  private readonly oauthService = inject(OAuthService);


  ngOnInit(): void {
    this.oauthService.initCodeFlow();
  }
}
